import { library } from '@fortawesome/fontawesome-svg-core';
import { faFillDrip } from '@fortawesome/free-solid-svg-icons';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { SliderInput } from './SliderInput';

library.add(faFillDrip);

interface IOpacityControlProps {
  onOpacityLevelChange: (opacityLevel: number) => void;
  opacityLevel: number;
  minOpacityLevel: number;
  maxOpacityLevel: number;
}

export const OpacityControl = observer((props: IOpacityControlProps): ReactElement => {
  const { t } = useTranslator();

  const renderValue = (opacityLevel: number): ReactElement => <>{opacityLevel}%</>;

  return (
    <SliderInput
      icon={faFillDrip}
      label={t('opacity')}
      min={props.minOpacityLevel}
      max={props.maxOpacityLevel}
      step={5}
      value={props.opacityLevel}
      onChange={props.onOpacityLevelChange}
      renderValue={renderValue}
    />
  );
});
